const differentiators = [
  {
    icon: 'ri-award-fill',
    title: 'Decades of Hands-On Experience',
    desc: 'We\'ve serviced thousands of Metro Atlanta homes and businesses. Every flooring challenge — we\'ve solved it.',
  },
  {
    icon: 'ri-shield-check-fill',
    title: '100% Satisfaction Guarantee',
    desc: 'Not completely satisfied? We return and re-service at no charge. No fine print. No excuses. That\'s our promise.',
  },
  {
    icon: 'ri-heart-fill',
    title: 'Christian Values & Ethics',
    desc: 'We treat every client like family. Honest pricing, transparent communication, and genuine care for your home.',
  },
  {
    icon: 'ri-leaf-fill',
    title: 'Eco-Friendly Solutions',
    desc: 'Our cleaning products are safe for children, pets, and the environment — without compromising on results.',
  },
  {
    icon: 'ri-tools-fill',
    title: 'Professional-Grade Equipment',
    desc: 'Truck-mounted systems, commercial extractors, and precision installation tools — the best in the industry.',
  },
  {
    icon: 'ri-building-2-fill',
    title: 'Full-Service Flooring Partner',
    desc: 'Carpet cleaning to LVP installation to hardwood refinishing — one trusted company handles everything.',
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="py-28 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0993de50115241fad3523148b0f2ae08.jpg"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-stone-950/91"></div>
        {/* Subtle amber glow top-left */}
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-amber-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <p className="text-amber-400 text-[11px] font-bold tracking-[0.25em] uppercase mb-3">The Difference</p>
            <h2 className="font-serif text-4xl md:text-5xl text-white leading-tight">
              Why Carpet &amp; Flooring<br className="hidden md:block" /> Transformers?
            </h2>
          </div>
          <div className="max-w-sm">
            <p className="text-stone-400 text-base leading-relaxed">
              Not all flooring companies are equal. Here&apos;s what sets us apart from the rest.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-white/8 mb-14"></div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {differentiators.map((item, i) => (
            <div
              key={item.title}
              className={`group border rounded-xl p-7 transition-all duration-300 cursor-default ${
                i === 0
                  ? 'border-amber-500/40 bg-amber-500/8 hover:bg-amber-500/12'
                  : 'border-white/8 hover:border-amber-500/30 hover:bg-white/4'
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center mb-5 ${i === 0 ? 'text-amber-400' : 'text-amber-500/70 group-hover:text-amber-400'} transition-colors`}>
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-white font-bold text-base mb-3 leading-snug">{item.title}</h3>
              <p className="text-stone-400 text-sm leading-relaxed group-hover:text-stone-300 transition-colors">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#estimate-form"
            className="inline-flex items-center gap-2.5 bg-amber-500 hover:bg-amber-400 text-stone-950 font-extrabold text-sm px-10 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            Experience the Difference — Free Estimate
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
          <a
            href="tel:7702361255"
            className="inline-flex items-center gap-2 border border-white/20 hover:border-white/40 text-white font-semibold text-sm px-10 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line"></i>
            </div>
            770.236.1255
          </a>
        </div>
      </div>
    </section>
  );
}
